import styled from "styled-components"

import { memo, useCallback, useMemo } from "react"
import ProgressBar from "./ProgressBar"
import FirstStepsCard, { FirstStepCardProps } from "./FirstStepsCard"
import { useNavigate } from "react-router-dom"
import { firstSteps, firstStepsTotal } from "constants/firstSteps"
import { contentSections } from "../ListContentHome/ListContent"

const Container = styled.div`
  max-width: 968px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
`

const FirstStepsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

export interface FirstStepsStatus {
  hasProduct: boolean
  hasEventType: boolean
  hasPurchasePlan: boolean
}

export interface FirstStepProps {
  setIsOpen: React.Dispatch<React.SetStateAction<contentSections>>
  firstStepsStatus: FirstStepsStatus
  completedStepsCount: number
}

const FirstSteps = (props: FirstStepProps) => {
  const { setIsOpen, firstStepsStatus, completedStepsCount } = props

  const navigate = useNavigate()

  const handleClickProducts = useCallback(() => {
    navigate("/products")
  }, [navigate])

  const handleClickEventTypes = useCallback(() => {
    navigate("/event-types")
  }, [navigate])

  const handleClickPurchasePlans = useCallback(() => {
    navigate("/purchase-plans")
  }, [navigate])

  const stepsList: FirstStepCardProps[] = useMemo(() => {
    return [
      {
        ...firstSteps[0],
        onButtonClick: handleClickProducts,
        completed: firstStepsStatus.hasProduct,
        disabled: false
      },
      {
        ...firstSteps[1],
        onButtonClick: handleClickEventTypes,
        completed: firstStepsStatus.hasEventType,
        disabled: !firstStepsStatus.hasProduct
      },
      {
        ...firstSteps[2],
        onButtonClick: handleClickPurchasePlans,
        completed: firstStepsStatus.hasPurchasePlan,
        disabled: !firstStepsStatus.hasEventType
      }
    ]
  }, [firstStepsStatus, handleClickProducts, handleClickEventTypes, handleClickPurchasePlans])

  return (
    <Container>
      <ProgressBar completedSteps={completedStepsCount} totalSteps={firstStepsTotal} />
      <FirstStepsContainer>
        {stepsList.map((step, index) => (
          <FirstStepsCard key={index} {...step} setIsOpen={setIsOpen} />
        ))}
      </FirstStepsContainer>
    </Container>
  )
}

export default memo(FirstSteps)
